import moment from "moment";
import React from "react";
import { Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Switch from "react-switch";
import GlobalCatalogViewDetails, {
  GlobalCatalogDeletePopUp,
} from "./GlobalCatalogViewDetails";

export const ChainTablesHead = (props) => {
  return (
    <tr>
      <th style={{ width: "8%" }}>
        Chain <br />
        Name/ID
      </th>
      <th style={{ width: "8%" }}>
        Catalogue <br />
        ID
      </th>
      <th style={{ width: "8%" }}>Name</th>
      <th style={{ width: "30%" }}>Description</th>
      <th style={{ width: "6%" }}>
        No. <br />
        Items
      </th>
      <th style={{ width: "8%" }}>Status</th>
      <th style={{ width: "12%" }}>
        Created Date &<br /> Time
      </th>
      <th style={{ width: "20%" }}>Actions</th>
    </tr>
  );
};

export const ChainTablesBody = (props) => {
  return (
    <React.Fragment>
      {props &&
        props.data &&
        props.data.map((catalog, index) => (
          <tbody key={index}>
            <tr className="super_admin_all_users_table_body">
              <td style={{ width: "8%" }}>
                <Image
                  src={
                    catalog &&
                    catalog.restaurant_chain_id &&
                    catalog.restaurant_chain_id.icon
                  }
                  alt="Chain Image"
                  height="50px"
                />
                <div className="f12-500">
                  {catalog &&
                    catalog.restaurant_chain_id &&
                    catalog.restaurant_chain_id.title}
                </div>
                <div className="f10-400 text-break">
                  #
                  {catalog &&
                    catalog.restaurant_chain_id &&
                    catalog.restaurant_chain_id._id}
                </div>
              </td>
              <td className="text-break" style={{ width: "8%" }}>
                <div className="f14-500">#{catalog._id} </div>
              </td>
              <td style={{ width: "8%" }}>
                <div className="f15-500">{catalog.name}</div>
              </td>
              <td style={{ width: "30%" }}>
                <div className="f14-500">{catalog.description}</div>
              </td>
              <td style={{ width: "6%" }}>
                <NavLink
                  to={`/superadmin-chain-catalogue/catalogue/${catalog._id}`}
                >
                  <div className="f15-500" style={{ color: "#2196F3" }}>
                    {catalog && catalog.items && catalog.items.length}
                  </div>
                </NavLink>
              </td>
              <td style={{ width: "8%" }}>
                <div className="f15-500">
                  <Switch
                    onChange={() =>
                      props.onChangeChainStatus(catalog.status, catalog._id)
                    }
                    checked={catalog.status}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                </div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f14-500">
                  {moment(catalog.createdAt).format("Do MMMM YYYY, h:mm a")}
                </div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="d-flex">
                  <GlobalCatalogDeletePopUp
                    catalogId={catalog._id}
                    type="chain"
                    title="Delete Catalogue"
                    subtitle="Are you sure you want to delete this catalogue?"
                    deleteChainCatalog={() =>
                      props.deleteChainCatalog(catalog._id)
                    }
                  />
                  <GlobalCatalogViewDetails
                    name="Chain"
                    data={catalog}
                    displayView={"GlobalCatalog"}
                  />

                  <div
                    className="enIconBtn mr-3"
                    onClick={() => props.editChainData(catalog)}
                    // to={`/superadminoffers/edit-admin-offline-offer/`}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit Catalog"
                      title="Edit Catalog"
                      fluid
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        ))}
    </React.Fragment>
  );
};
